// src/Encoding.ts
var Encoding = class {
  getSegmentsCount(text) {
    const length = this.getTextLength(text);
    if (length <= this.getMaxSmsSegmentLength()) {
      return 1;
    }
    return Math.ceil(length / this.getMaxConcatenatedSmsSegmentLength());
  }
  getMaxTextLength(segmentsCount) {
    if (typeof segmentsCount !== "number" || segmentsCount <= 0) {
      throw "Segments count should be a positive number.";
    }
    return segmentsCount === 1 ? this.getMaxSmsSegmentLength() : this.getMaxConcatenatedSmsSegmentLength() * segmentsCount;
  }
};
var Encoding_default = Encoding;

// src/UCS2.ts
var UCS2 = class extends Encoding_default {
  getMaxSmsSegmentLength() {
    return 70;
  }
  getMaxConcatenatedSmsSegmentLength() {
    return 67;
  }
  getTextLength(text) {
    return (text != null ? text : "").length;
  }
  getSampleCharacter() {
    return "\xFA";
  }
};
var UCS2_default = UCS2;

// src/GSM7.ts
var GSM7 = class extends Encoding_default {
  static getCodePoints() {
    return {
      10: [10],
      12: [27, 10],
      13: [13],
      32: [32],
      33: [33],
      34: [34],
      35: [35],
      36: [2],
      37: [37],
      38: [38],
      39: [39],
      40: [40],
      41: [41],
      42: [42],
      43: [43],
      44: [44],
      45: [45],
      46: [46],
      47: [47],
      48: [48],
      49: [49],
      50: [50],
      51: [51],
      52: [52],
      53: [53],
      54: [54],
      55: [55],
      56: [56],
      57: [57],
      58: [58],
      59: [59],
      60: [60],
      61: [61],
      62: [62],
      63: [63],
      64: [0],
      65: [65],
      66: [66],
      67: [67],
      68: [68],
      69: [69],
      70: [70],
      71: [71],
      72: [72],
      73: [73],
      74: [74],
      75: [75],
      76: [76],
      77: [77],
      78: [78],
      79: [79],
      80: [80],
      81: [81],
      82: [82],
      83: [83],
      84: [84],
      85: [85],
      86: [86],
      87: [87],
      88: [88],
      89: [89],
      90: [90],
      91: [27, 60],
      92: [27, 47],
      93: [27, 62],
      94: [27, 20],
      95: [17],
      97: [97],
      98: [98],
      99: [99],
      100: [100],
      101: [101],
      102: [102],
      103: [103],
      104: [104],
      105: [105],
      106: [106],
      107: [107],
      108: [108],
      109: [109],
      110: [110],
      111: [111],
      112: [112],
      113: [113],
      114: [114],
      115: [115],
      116: [116],
      117: [117],
      118: [118],
      119: [119],
      120: [120],
      121: [121],
      122: [122],
      123: [27, 40],
      124: [27, 64],
      125: [27, 41],
      126: [27, 61],
      161: [64],
      163: [1],
      164: [36],
      165: [3],
      167: [95],
      191: [96],
      196: [91],
      197: [14],
      198: [28],
      201: [31],
      209: [93],
      214: [92],
      216: [11],
      220: [94],
      223: [30],
      224: [127],
      228: [123],
      229: [15],
      230: [29],
      199: [9],
      232: [4],
      233: [5],
      236: [7],
      241: [125],
      242: [8],
      246: [124],
      248: [12],
      249: [6],
      252: [126],
      915: [19],
      916: [16],
      920: [25],
      923: [20],
      926: [26],
      928: [22],
      931: [24],
      934: [18],
      936: [23],
      937: [21],
      8364: [27, 101]
    };
  }
  getMaxSmsSegmentLength() {
    return 160;
  }
  getMaxConcatenatedSmsSegmentLength() {
    return 153;
  }
  getTextLength(text) {
    let length = 0;
    (text != null ? text : "").split("").forEach((char) => {
      const codeUnits = this.constructor.getCodePoints()[char.charCodeAt(0)];
      length += codeUnits ? codeUnits.length : 1;
    });
    return length;
  }
  getSampleCharacter() {
    return "_";
  }
};
var GSM7_default = GSM7;

// src/EncodedText.ts
var EncodedText = class _EncodedText {
  constructor(text, forceEncoding = null) {
    this.text = text != null ? text : "";
    this.encoding = this.detectEncoding(this.text, forceEncoding);
  }
  detectEncoding(text, forceEncoding = null) {
    if (forceEncoding instanceof UCS2_default) {
      return forceEncoding;
    }
    const containsAtLeastOneNonGsmCharacter = text.split("").some((char) => !GSM7_default.getCodePoints().hasOwnProperty(char.charCodeAt(0)));
    if (containsAtLeastOneNonGsmCharacter && forceEncoding instanceof GSM7_default) {
      throw "Non-GSM character encountered.";
    }
    if (forceEncoding instanceof GSM7_default) {
      return forceEncoding;
    }
    return containsAtLeastOneNonGsmCharacter ? new UCS2_default() : new GSM7_default();
  }
  getValue() {
    return this.text;
  }
  getEncoding() {
    return this.encoding;
  }
  getLength() {
    return this.getEncoding().getTextLength(this.getValue());
  }
  getNumberOfSegments() {
    return this.getEncoding().getSegmentsCount(this.getValue());
  }
  limit(length) {
    let value = this.getValue();
    while (this.getEncoding().getTextLength(value) > length) {
      value = value.slice(0, -1);
    }
    return new _EncodedText(value, this.getEncoding());
  }
  isGsm7() {
    return this.getEncoding() instanceof GSM7_default;
  }
  isUcs2() {
    return this.getEncoding() instanceof UCS2_default;
  }
};
var EncodedText_default = EncodedText;

// src/normalizeSpecialCharacters.ts
var normalizedCharactersAsObject = {
  '"': "\xAB|\xBB|\u201C|\u201D|\u02BA|\u02EE|\u201F|\u275D|\u275E|\u301D|\u301E|\u301F|\uFF02|\u201E",
  "'": "\u2018|\u2019|\u02BB|\u02C8|\u02BC|\u02BD|\u02B9|\u201B|\uFF07|\xB4|\u02CA|`|\u02CB|\u275B|\u275C|\u0313|\u0314|\uFE10|\uFE11",
  "/": "\u29F8|\u0337|\u0338|\u2044|\u2215|\uFF0F",
  "\\": "\u29F9|\u29F5|\u20E5|\uFE68|\uFF3C",
  _: "\u0332|\uFF3F",
  "|": "\u20D2|\u20D3|\u2223|\uFF5C|\u23B8|\u23B9|\u23D0|\u239C|\u239F",
  "-": "\u23BC|\u23BD|\u2015|\uFE63|\uFF0D|\u2010|\u2043|\u2017|\u2014|\u2013",
  "@": "\uFE6B|\uFF20",
  $: "\uFE69|\uFF04",
  "!": "\u01C3|\uFE15|\uFE57|\uFF01|\u203C",
  "#": "\uFE5F|\uFF03",
  "%": "\xF7|\uFE6A|\uFF05",
  "&": "\uFE60|\uFF06",
  ",": "\u201A|\u0326|\uFE50|\uFE51|\uFF0C|\uFF64",
  "(": "\u2768|\u276A|\uFE59|\uFF08|\u27EE|\u2985",
  ")": "\u2769|\u276B|\uFE5A|\uFF09|\u27EF|\u2986",
  "*": "\u204E|\u2217|\u229B|\u2722|\u2723|\u2724|\u2725|\u2731|\u2732|\u2733|\u273A|\u273B|\u273C|\u273D|\u2743|\u2749|\u274A|\u274B|\u29C6|\uFE61|\uFF0A",
  "+": "\u02D6|\uFE62|\uFF0B",
  ".": "\u3002|\uFE52|\uFF0E|\uFF61",
  ":": "\u02D0|\u02F8|\u2982|\uA789|\uFE13|\uFF1A",
  ";": "\u204F|\uFE14|\uFE54|\uFF1B",
  "<": "\uFE64|\uFF1C|\u2039|\u276E",
  "=": "\u0347|\uA78A|\uFE66|\uFF1D",
  ">": "\uFE65|\uFF1E|\u203A|\u276F",
  "?": "\uFE16|\uFE56|\uFF1F",
  "^": "\u02C6|\u0302|\uFF3E|\u1DCD",
  "{": "\u2774|\uFE5B|\uFF5B",
  "}": "\u2775|\uFE5C|\uFF5D",
  "[": "\uFF3B",
  "]": "\uFF3D",
  "~": "\u02DC|\u02F7|\u0303|\u0334|\u223C|\uFF5E",
  " ": "\xA0|\u2000|\u2001|\u2002|\u2003|\u2004|\u2005|\u2006|\u2007|\u2008|\u2009|\u200A|\u202F|\u205F|\u3000|\x8D|\x9F|\x80|\x90|\x9B||	|\0|||||||||\u2028|\u2029|\u2060",
  "...": "\u2026",
  "": "\xAD|\u200B|\u2060|\uFEFF"
};
var normalizedCharactersAsKeys = {};
Object.keys(normalizedCharactersAsObject).forEach((key) => {
  normalizedCharactersAsObject[key].split("|").forEach((c) => {
    normalizedCharactersAsKeys[c] = key;
  });
});
var normalizedCharactersAsStringWithSeparator = Object.values(
  normalizedCharactersAsObject
).join("|");
var normalizedCharactersRegExp = new RegExp(
  normalizedCharactersAsStringWithSeparator,
  "g"
);
function normalizeSpecialCharacters(text) {
  return text.replace(normalizedCharactersRegExp, (match) => {
    return normalizedCharactersAsKeys[match];
  });
}
var normalizeSpecialCharacters_default = normalizeSpecialCharacters;
export {
  EncodedText_default as EncodedText,
  Encoding_default as Encoding,
  GSM7_default as GSM7,
  UCS2_default as UCS2,
  normalizeSpecialCharacters_default as normalizeSpecialCharacters
};
